exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ItemCard{width:calc(100% - 68px);background:#fff;border:1px solid #d1d1d1;margin-top:20px;border-radius:5px;position:relative}.ItemCard img{max-width:100%}.ItemCard .actions{position:absolute;right:-49px;top:3px}.ItemCard .actions .icon{cursor:pointer}.ItemCard hr{margin:0!important}.ItemCard .answer{padding:10px}.ItemCard .question{padding:10px;display:flex}.ItemCard .question .image{width:33%;display:flex;align-items:center;justify-content:center}.ItemCard .question .image img{max-width:100%}.ItemCard .question .text{display:flex;flex:auto;align-items:center;width:67%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/CardTrashed/components/Cards/components/Item/style.scss
// module id = 5158
// module chunks = 0